import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";

/**
 * Returns the default value for a file_upload field
 */
export function getFileUploadDefaultValue(): FieldValue {
  return null;
}
